import React, { useEffect } from 'react'
import SectionHeader from '../ui/SectionHeader'
import { useTranslation } from 'react-i18next'
import { Article } from '../../types'
import ArticleCard from '../common/ArticleCard'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchArticles } from '../../features/admin/articleSlice'
import Loading from '../ui/Loading'

const Articles = () => {
    const {t}=useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { articles,loading} = useSelector((state: RootState) => state.articleSlice);
        useEffect(() => {
            dispatch(fetchArticles());
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [dispatch])
    if(articles.length===0) return null;
       if(loading) return <Loading/>
  return (
    <div className=' main-prop padding-container '>
        <SectionHeader title={t("articles")} text={t("articles-text")} />
        <ul className=' grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-2 xs:grid-cols-1 gap-5 mt-8 '>
            {articles.slice(-5).map((articele:Article,index:number)=>(
                <li key={index} className='rounded-lg overflow-hidden bg-white'>
                    <ArticleCard article={articele}/>
                </li>
            ))}
        </ul>
    </div>
  )
}

export default Articles